import { JOB_ACTION_INTENT, TARGET_STATUS_CODE, getJobStatusActions, resolveJobActionGate } from './jobStatus'

// Historia 160 (RN20/D13) — la ÚNICA regla de acciones de la cabecera del detalle del job.
//
// El detalle no copia la celda de la fila: la fila decide Join por pestaña («All Active Jobs») y el
// detalle es uno solo para los tres puntos de entrada, así que decide por los HECHOS del job que
// publica Sun en D1. La precedencia es fija y es lo que fijan S58 y S59:
//
//   1. gating MoD / circuito externo  ⇒ ninguna acción (Start deshabilitado con el tooltip de la fila)
//   2. activo en otra máquina y no en la del puesto ⇒ solo Join
//   3. en otro caso ⇒ la tabla por estado de la fila (`getJobStatusActions`)
//
// El gating y su tooltip salen de `resolveJobActionGate`, la misma pieza que usa la fila: ninguna de
// las dos superficies copia la condición (R-16).

const JOIN = { label: 'Join', statusCode: TARGET_STATUS_CODE.START, intent: JOB_ACTION_INTENT.START }

/**
 * @param {Object} job `job` de D1 (`status`, `governedByAcceptance`, `externalCircuitJob`,
 *   `activeInRequestingDevice`, `activeInOtherDevices`)
 * @returns {{ actions: Array<{label: string, statusCode: string, intent: string}>, gated: boolean, tooltipKey: string }}
 */
export const resolveDetailActions = (job = {}) => {
  const gate = resolveJobActionGate(job)
  if (gate.gated) {
    return { actions: [], gated: true, tooltipKey: gate.tooltipKey }
  }
  if (job.activeInOtherDevices === true && job.activeInRequestingDevice !== true) {
    return { actions: [JOIN], gated: false, tooltipKey: '' }
  }
  return { actions: getJobStatusActions(job.status), gated: false, tooltipKey: '' }
}
